import React from 'react';
import { ComingSoonPage } from './ComingSoonPage';

export function BrandGuidelines() {
  return (
    <ComingSoonPage
      title="Brand Guidelines"
      description="Define your brand's personality, tone of voice, and target audience to ensure consistent messaging across all your content."
      estimatedDate="Q2 2024"
      icon={
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      }
      features={[
        "Define your brand's tone of voice (professional, friendly, casual, etc.)",
        "Set target audience demographics and preferences",
        "Specify brand values and messaging guidelines",
        "Create custom writing style instructions for AI",
        "Set content themes and topics to focus on",
        "Define what to avoid in your brand communication"
      ]}
    />
  );
}
